<template>
  <transition name="projet" @enter="enter" v-on:leave="leave" appear>
    <div>
      <div class="transition-block white"></div>
      <div class="transition-block black"></div>
      <article class="global parallax">
        <div class="top-container">
          <div class="image-container">
            <img
              ref="imageTop"
              class="image-top"
              src="../../../static/images/projets/illustration-svg.jpg"
              alt="Aperçu de l'illustration réalisée"
            />
          </div>
          <div class="title-projet-container">
            <h3>Belfort By Night</h3>
          </div>
          <div class="scroll-down">
            <button class="iconbutton">
              <div class="scroll">
                <div class="scroll__wheel"></div>
              </div>
            </button>
          </div>
        </div>

        <div class="project-content" style="height: 200vh; ">
          <div class="presentation">
            <div class="type-projet splited">
              <h4>PROJET</h4>
              <ul>
                <li>Illustrations SVG | Adobe Illustrator</li>
                <li>Animations | CSS</li>
              </ul>
            </div>
            <div class="annee-projet splited">
              <h4>DATE</h4>2019
            </div>
          </div>
          <div class="description">
            <h4>DESCRIPTION</h4>
            <p>
              Pour cet exercice de graphisme au semestre 1, l’objectif était de représenter
              3 « monuments » de Belfort ou Montbéliard. Le tout en apportant une ambiance bien
              spécifique. Pour ma part, j’ai choisi la gare, le conservatoire et la Maison du
              Peuple de Belfort. J’ai réalisé l’illustration sur Illustrator en essayant de donner
              une ambiance « début de soirée ». Puis l’ensemble a été exporté en SVG et intégré
              dans un site web. De cette manière, j’ai pu apporter plus de vie à ce paysage en
              créant des animations en CSS (nuages, lumières, voitures, vélo…).
            </p>
            <div class="content-image-projet">
              <img
                class="img-w-bg"
                src="../../../static/images/Illustrations/illustration-part-100-01.jpg"
                alt="Animation d'entrée de l'illustartion SVG"
              />
              <img
                class="img-w-bg"
                src="../../../static/images/Illustrations/illustration-part-100-02.jpg"
                  alt="Animation d'entrée de l'illustartion SVG"
              />
              <img
                class="img-w-bg"
                src="../../../static/images/Illustrations/illustration-part-100-03.jpg"
                  alt="Animation d'entrée de l'illustartion SVG"
              />
              <img
                class="img-w-bg"
                src="../../../static/images/Illustrations/illustration-part-100-04.jpg"
                  alt="Animation d'entrée de l'illustartion SVG"
              />
            </div>
            <h4>POURQUOI ?</h4>
            <p class="need-margin">
              Le style flat design a été prévilégié afin d'apporter une certaine modernité à l'ensemble de l'illustration. On peut tout de même
              remarquer quelques dégradés (dans le ciel et sur le sol), notament pour simuler le coucher de soleil. Les animations ont été réalisées en pure CSS. Cependant, si cela
              était à refaire, j'utiliserais sans hésiter la librairie GSAP, qui permet une mailleure gestion des animations, plus simplement.
            </p>
             <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://davyjacquemard.com/projets/belfort-by-night/"
              @mouseenter="onLinkMouseEnter"
              @mouseleave="onLinkMouseLeave"
            >
              <h4 class="link">VOIR LE PROJET</h4>
              <img
                class="external-arrow"
                src="../../../static/images/icones/diagonal-arrow.png"
                alt="Icone"
              />
            </a>
          </div>
          <div class="projet-suivant">
            <span>PROJET SUIVANT</span>
            <router-link to="/asso-lard">
              <div class="next-container" ref="nextContainer">
                <div
                  @mouseenter="nextFxEnter"
                  @mouseleave="nextFxLeave"
                  @click="nextFxLeave"
                  ref="btnNext"
                  class="projet-suivant-content"
                >L.A.R.D.</div>

                <svg class="arrow-cursor-bottom__icon" ref="arrowCursorIcon" viewBox="0 0 117.25 86.75">
                  <path
                    class="arrow-cursor-bottom__path"
                    ref="arrowCursorPath"
                    d="M111.45,42.5,74.65,5.7l-9.9,9.9,20.6,20.6H6.45v14h78.9L64.75,70.8l9.9,9.9,36.8-36.8A1,1,0,0,0,111.45,42.5Z"
                  />
                </svg>
              </div>
            </router-link>
          </div>
        </div>
      </article>
    </div>
  </transition>
</template>

<script>
//import Nearby from "../../script/nearby";
export default {
  name: "Sachassou",
  data() {
    return {};
  },
  methods: {
    enter(el, done) {
      var imageTop = el.querySelector(".top-container .image-container");

      TweenMax.set(imageTop, {
        opacity: 0
      });
      TweenMax.to(imageTop, 1, {
        delay: 1.4,
        opacity: 1,
        ease: Power4.easeOut
      });
      var image = el.querySelector(".top-container img");
      TweenMax.set(image, {
        filter: "brightness(50%)"
      });
      TweenMax.to(image, 1, {
        delay: 2,
        filter: "brightness(50%)",
        ease: Power4.easeOut
      });

      var title = el.querySelector(".title-projet-container h3");
      TweenMax.set(title, {
        //scale: 200
        y: "100%"
      });
      TweenMax.to(title, 0.8, {
        delay: 2,
        //scale: 1,
        y: 0,
        ease: Power4.easeOut,
        onComplete: done
      });
      var scroll = el.querySelector(".iconbutton");
      TweenMax.set(scroll, {
        y: "120%"
      });
      TweenMax.to(scroll, 0.8, {
        delay: 3,
        y: 0,
        ease: Power4.easeOut
      });
    },
    leave(el, done) {
       var blockWhite = el.querySelector(".transition-block.white");
      var blockBlack = el.querySelector(".transition-block.black");
       TweenMax.to(blockWhite, 0.8, {
        height: '100vh',
        ease: Power4.easeOut,
        
      });
      TweenMax.to(blockBlack, 0.8, {
        delay: 0.4,
        height: '100vh',
        ease: Power4.easeOut,
        onComplete: done
      });
    },
    scrollButtonEffect() {
      const distanceThreshold = { min: 0, max: 100 };
      const iconWrapperScroll = document.querySelector(".scroll");
      const iconScrollButton = iconWrapperScroll.parentNode;
      const scrollWheel = iconWrapperScroll.querySelector(".scroll__wheel");

      const scrollInterval = { from: 1, to: 15 };

      TweenMax.to(scrollWheel, 1, {
        repeat: -1,
        yoyo: false,
        y: 32,
        scaleY: 0
      });
    },
    nextFxEnter() {
      var btnNext = this.$refs.btnNext;
      var nextContainer = this.$refs.nextContainer;
      var arrowCursorIcon = this.$refs.arrowCursorIcon;
      var arrowCursorPath = this.$refs.arrowCursorPath;

      TweenMax.to(btnNext, 0.5, {
        color: "#ea5242"
      });
      TweenMax.to(nextContainer, 0.5, {
        x: "-4vw",
        ease: "back.out(1.7)"
      });
      TweenMax.to(arrowCursorIcon, 0.5, {
        x: "6vw",
        ease: "back.out(1.7)"
      });
      var cursorCircle = document.querySelector(".cursor__inner--circle");

      cursorCircle.classList.add("cursor-animate");
      TweenMax.to(cursorCircle, 0.3, {
        width: 60 + "px",
        height: 60 + "px",
        top: -20 + "px",
        left: -20 + "px",
        ease: "back.out(1.7)"
      });
    },
    nextFxLeave() {
      var btnNext = this.$refs.btnNext;
      var nextContainer = this.$refs.nextContainer;
      var arrowCursorIcon = this.$refs.arrowCursorIcon;
      var arrowCursorPath = this.$refs.arrowCursorPath;
      TweenMax.to(btnNext, 0.5, {
        color: "#fff"
      });
      TweenMax.to(nextContainer, 0.5, {
        x: 0,
        ease: "back.out(1.7)"
      });
      TweenMax.to(arrowCursorIcon, 0.5, {
        x: 0,
        ease: "back.out(1.7)"
      });
      var cursorCircle = document.querySelector(".cursor__inner--circle");
      cursorCircle.classList.remove("cursor-animate");
      TweenMax.to(cursorCircle, 0.3, {
        width: 20,
        height: 20,
        top: 0,
        left: 0,
        ease: "back.out(1.7)"
      });
    },
    onLinkMouseEnter() {
      var cursorCircle = document.querySelector(".cursor__inner--circle");
      cursorCircle.classList.add("cursor-animate");
      TweenMax.to(cursorCircle, 0.3, {
        width: 60 + "px",
        height: 60 + "px",
        top: -20 + "px",
        left: -20 + "px",
        ease: "back.out(1.7)"
      });
    },
    onLinkMouseLeave() {
      var cursorCircle = document.querySelector(".cursor__inner--circle");
      cursorCircle.classList.remove("cursor-animate");
      TweenMax.to(cursorCircle, 0.3, {
        width: 20,
        height: 20,
        top: 0,
        left: 0,
        ease: "back.out(1.7)"
      });
    }
  },
  mounted() {
    this.scrollButtonEffect();
  }
};
</script>

<style scoped lang='scss'>
@import "../../assets/css/structure-projet.scss";
.img-w-bg {
  margin-bottom: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/projets/BelfortByNight.vue